var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg15Min(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B2BDACB1-7972-4C15-A60D-A795EB243B01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "landing",
    transform: "translate(-120, -1996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(100, 1701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kaip-digitouch.lt",
    transform: "translate(0, 265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15min_logo_spalvotas_CMYK",
    transform: "translate(20, 30)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    points: "0 50 50 50 50 0 0 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(7.2044, 12.0023)",
    fill: "#60CA68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.65545336,6.63420268 L0,6.63420268 L0,3.22644996 C3.806392,3.11759271 5.58279787,2.86401243 6.8516232,4.19973958e-05 L10.6582672,4.19973958e-05 L10.6582672,26.2831044 L5.65545336,26.2831044 L5.65545336,6.63420268 Z",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1988157,12.289698 C21.8786275,12.289698 20.2108269,13.4496661 19.7035824,14.6822897 L15.1356096,14.4648272 L16.8758137,0 L33.080761,0 L33.080761,4.20519928 L20.9723237,4.20519928 L20.2473647,9.82445088 C21.3348452,9.02675234 23.0385956,8.37436479 25.467641,8.37436479 C29.9628743,8.37436479 34.1317878,11.564655 34.1317878,17.6185796 C34.1317878,23.419092 29.6365545,26.7544412 24.2350174,26.7544412 C18.0718995,26.7544412 14.8092898,22.549074 14.5194238,18.0175549 L19.2322036,18.0175549 C19.5223216,20.7364663 21.080929,22.984251 24.3074209,22.984251 C27.0627861,22.984251 29.0565705,20.9901306 29.0565705,17.6550334 C29.0565705,14.0661039 26.6275251,12.289698 24.1988157,12.289698",
    id: "Fill-4"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15Min);
export default __webpack_public_path__ + "static/media/15min.cd78e1f40930846861a8495fc53a95ed.svg";
export { ForwardRef as ReactComponent };